import { NgxEfFlagsComponent } from './ngx-ef-flags.component';
import { NgModule } from '@angular/core';
import { FlagTypePipe } from './flag-type.pipe';

@NgModule({
  declarations: [NgxEfFlagsComponent, FlagTypePipe],
  imports: [ ],
  exports: [NgxEfFlagsComponent, FlagTypePipe]
})
export class NgxEfFlagsModule { }
